import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const ClientsReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                errMess: null,
                clients:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.CLIENTS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, clients: [], loadTime: Date.now()}

        case ActionTypes.ADD_CLIENTS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clients: action.payload};

        case ActionTypes.CLIENTS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null};

        case ActionTypes.ADD_CLIENT:
            const nClient = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clients: state.clients.concat(nClient)};
    
        case ActionTypes.UPDATE_CLIENT:
            const uClient = action.payload;
            const updatedClients = state.clients.map(e => e.id === uClient.id ? uClient : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clients: updatedClients};

        // case ActionTypes.DELETE_CLIENT:
        //     const deId = action.payload;
        //     const filteredClients = state.clients.filter(e => e.id !== deId);
        //     return {...state, isLoading: false, errMess: null, clients: filteredClients};

        default:
            return state;
    }
};